'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { clientLogger } from '@/lib/client-logger';
import { useAuth } from '@/providers/auth-provider';
const REPORT_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Tells the server that the signed-in user runs the desktop app, so their browser can offer to
 * open PR and inbox links in the app. It reports every 5 minutes while the app runs, so the
 * server can also keep notification toasts out of the user's browser tabs meanwhile.
 */
export function DesktopAppSeenReporter() {
  const $ = _c(3);
  const {
    user
  } = useAuth();
  const userId = user?.id;
  let t0;
  let t1;
  if ($[0] !== userId) {
    t0 = () => {
      if (!userId) {
        return;
      }
      const report = _temp2;
      report();
      const interval = setInterval(report, REPORT_INTERVAL_MS);
      return () => clearInterval(interval);
    };
    t1 = [userId];
    $[0] = userId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}
function _temp2() {
  fetch("/api/desktop/seen", {
    method: "POST"
  }).catch(_temp);
}
function _temp(error) {
  clientLogger.error("Failed to report desktop app usage", error);
}